import { InjectionToken } from '@angular/core';

/**
 * An injection token to resolve the configuration of the cart service
 */
export const CART_SERVICE_CONFIGURATION = new InjectionToken<any>('CartServiceConfiguration');
